module.exports = __webpack_public_path__ + "static/751dc3.png";